import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";

const StandardMIS = () => {
  const [datelist, setDatelist] = useState([]);

  const FillDetail = () => {
    const Datelst = [
      { name: "Field Activity Detail", reportUrl: "/fieldactivitydetailreport", icon: "fa-seedling" },
      { name: "Field Activity Plotwise Detail", reportUrl: "/fieldactivityplotwisedetailreport", icon: "fa-th-large" },
      { name: "Field Activity Cropwise Detail", reportUrl: "/fieldactivitycropwisedetail", icon: "fa-leaf" },
      { name: "Field Activity Farm Managerwise Detail", reportUrl: "/fieldactivityfarmmanagerwisereport", icon: "fa-user-tie" },
      { name: "Farm Managerwise Budget Approval", reportUrl: "/farmmanagerwisebudgetapprovaldetailreport", icon: "fa-check-circle" },
      { name: "Productwise Input consumption", reportUrl: "/productwiseinputconsumptiondetailreport", icon: "fa-flask" },
      { name: "Machinery Detail", reportUrl: "/machinerydetailreport", icon: "fa-cogs" },
      { name: "Yield Estimations", reportUrl: "/yieldestimationsstddetailreport", icon: "fa-chart-line" },
      { name: "Soil Observation Report", reportUrl: "/soilobservationdetailreport", icon: "fa-mountain" },
      { name: "Water Observation Report", reportUrl: "/waterobservationdetailreport", icon: "fa-tint" },
      { name: "My Stock Report", reportUrl: "/userstockdetailreport", icon: "fa-boxes" },
      { name: "Maturity Indices Report", reportUrl: "/maturityindicesdetailreport", icon: "fa-clock" },
      { name: "MRL Report", reportUrl: "/mrldetailreport", icon: "fa-vials" },
      { name: "Harvest Report", reportUrl: "/harvestdetailreport", icon: "fa-tractor" },
      { name: "Labour Report", reportUrl: "/labourdetailreport", icon: "fa-users" },
    ];
    setDatelist(Datelst);
  };

  useEffect(() => {
    FillDetail();
  }, []);

  const colors = [
    "#4caf50", "#03a9f4", "#f44336", "#9c27b0", "#ff9800",
    "#00bcd4", "#8bc34a", "#e91e63", "#2196f3", "#ffc107",
    "#607d8b", "#673ab7", "#009688", "#795548", "#ff5722",
  ];

  return (
    <div className="content-wrapper p-4">
      <h4 className="mb-4 text-primary">📘 Commercial / Standard Report Dashboard</h4>

      <div className="row">
        {datelist.map((item, index) => (
          <div className="col-md-4 mb-3" key={index}>
            <Link to={item.reportUrl} className="text-decoration-none">
              <div
                className="report-box d-flex align-items-center shadow-sm p-3 rounded"
                style={{
                  borderLeft: `10px solid ${colors[index % colors.length]}`,
                  backgroundColor: "#fff",
                }}
              >
                <div
                  className="icon-circle d-flex justify-content-center align-items-center mr-3"
                  style={{
                    backgroundColor: colors[index % colors.length],
                    color: "white",
                  }}
                >
                  <i className={`fas ${item.icon}`} />
                </div>
                <div className="report-name text-dark font-weight-bold">{item.name}</div>
              </div>
            </Link>
          </div>
        ))}
      </div>

      <style>{`
        .report-box {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          border-radius: 12px;
        }
        .report-box:hover {
          transform: translateY(-4px);
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
        }
        .icon-circle {
          width: 45px;
          height: 45px;
          border-radius: 50%;
          font-size: 18px;
          flex-shrink: 0;
        }
        .report-name {
          font-size: 15px;
          line-height: 1.3;
        }
      `}</style>
    </div>
  );
};

export default StandardMIS;
